import { render, staticRenderFns } from "./ItemViewer.vue?vue&type=template&id=f09666ac&scoped=true"
import script from "./ItemViewer.vue?vue&type=script&lang=ts"
export * from "./ItemViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09666ac",
  null
  
)

export default component.exports